// extracted by mini-css-extract-plugin
export default {"list":"style_list__bWS+2","list_item":"style_list_item__hqIA2","sm":"style_sm__B0m0x","logo":"style_logo__4TYA+"};